<ion-content *transloco="let t">
  <div class="safearea-wrapper">
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="ion-text-right"
        ><ion-icon name="close" (click)="onClose()"></ion-icon
      ></ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="10" class="content ion-text-center">
        <ion-row><h5>{{t('common.great')}}</h5></ion-row>
        <ion-row><h5>{{t('promotion.redeemSuccessMessage')}}</h5></ion-row>
        <ion-row *ngIf="!banner"
          ><ion-img class="icon" src="assets/images/smile.png"></ion-img>
        </ion-row>
        <ion-row *ngIf="sponsor" class="sponsor">
          <ion-col size="12"
            ><span style="margin-bottom: 0;">
              {{t('promotion.sponsorMessage', {sponsor: sponsor.name})}}
            </span></ion-col
          >
          <ion-col size="12">
            <ion-img class="logo" [src]="sponsor.logo"></ion-img> </ion-col
        ></ion-row>
        <ion-row *ngIf="banner"
          ><ion-col size="12"
            ><ion-img
              style="width: 100%; object-fit: contain;"
              [src]="banner"
            ></ion-img
          ></ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
  </div>
</ion-content>
